export const inputList = {
	default: [
		{
			label: 'First Name',
			name: 'firstName',
		},
		{
			label: 'Last Name',
			name: 'lastName',
		},
		{
			label: 'Job Title',
			name: 'jobTitle',
		},
	],
	contact: [
		{
			label: 'Office Phone',
			name: 'officePhone',
		},
		{
			label: 'Mobile Phone',
			name: 'mobilePhone',
		},
	],
}
